import React from 'react';
import { StyleSheet, View, Image, Platform } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../../core-res/R';
import { withTheme } from '../../../theme';
// Prefetch images on web only bc it's giving cryptic errors
// on apps, especially iOS
if (Platform.OS === 'web') {
    // Image.prefetch will try to read something from
    // global `window` namespace, so need to avoid it on SSR
    if (typeof window !== 'undefined') {
        Image.prefetch(require('../../../../images/checkmark.png'));
        Image.prefetch(require('../../../../images/grey-checkmark.png'));
    }
}
class Checkmark extends React.Component {
    render() {
        const { checked, color, theme } = this.props;
        const checkmarkColor = color ? color : theme.tintPrimary;
        return (<View style={[
            styles.checkboxContainer,
            {
                backgroundColor: checkmarkColor,
                borderColor: checkmarkColor,
            },
            !checked && { borderColor: theme.borderDivide },
        ]}>
        {!!checked && <Image source={require('../../../../images/checkmark.png')} style={styles.checkmarkImage}/>}
        <View style={StyleSheet.absoluteFill}>
          <View style={{
            width: checked ? '1%' : '100%',
            height: '100%',
            backgroundColor: checkmarkColor,
            marginLeft: checked ? '1%' : '100%',
        }}/>
        </View>
        <View key={checked} style={[
            StyleSheet.absoluteFill,
            { transform: [{ scale: checked ? 0.01 : 1 }], backgroundColor: theme.lightPrimary },
        ]}/>
        {!checked && <Image source={require('../../../../images/grey-checkmark.png')} style={styles.checkmarkImage}/>}
      </View>);
    }
}
Checkmark.propTypes = {
    checked: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    theme: PropTypes.object,
};
const styles = {
    checkmarkImage: {
        width: 9,
        height: 7,
    },
    checkboxContainer: {
        width: 20,
        height: 20,
        margin: 2,
        borderRadius: R.border.radius.default,
        overflow: 'hidden',
        borderWidth: R.border.width.thick,
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export default withTheme(Checkmark);
